import { BackendEnvironment, TripEnvironment } from '@tbums.mono.web/tbums-lib';

export const environment: TripEnvironment = {
  localEnvironment: BackendEnvironment.SameAsServer,
};
